import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {SelectValueInterface} from '@interfaces/select-value.interface';
import {ConclusionFormDataService} from '../../services/conclusion-form-data.service';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {Conclusion} from '@namespaces/conclusion.namespace';
import {DynamicFields} from '@namespaces/dynamic-fields.namespace';
import {filter, map} from 'rxjs/operators';
import {FormHelperService} from '@services/form-helper.service';

/**
 * Форма с параметрами испытания
 */
@Component({
    selector: 'app-conclusion-form-inspection',
    templateUrl: './conclusion-form-inspection-list.component.html',
    styleUrls: ['./conclusion-form-inspection-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ConclusionFormInspectionListComponent implements OnInit, OnDestroy {

    public statuses: SelectValueInterface[] = [];

    public list: Conclusion.InspectionWithForm[] = [];

    /**
     * Отфильтрованные параметры, которые должны быть отображены в таблице
     */
    public params: DynamicFields.ParamWithForm[] = [];

    public isInspectionSelected$ = this.formService.isInspectionSelected$;

    constructor(
        public formService: ConclusionFormDataService,
    ) {
    }

    get form(): FormGroup {
        return this.formService.form;
    }

    ngOnInit() {
        this.statuses = [];

        this.formService.inspectionsList$.pipe(
            untilDestroyed(this)
        ).subscribe((inspections) => {
            this.list = inspections;
            if (this.list && this.list.length) {
                this.params = this.list[0].showedParamsWithForm;
            }
        });

        this.formService.statuses$.pipe(
            map((v) => v && v.conclusion),
            filter((v) => Boolean(v)),
            untilDestroyed(this),
        ).subscribe((values: SelectValueInterface[]) => {
            if (!values.length) {
                this.statuses = [];
                FormHelperService.updateWithTouch(this.form.get('conclusion_status_id'), '');
                return;
            }

            this.statuses = values || [];
            const currentValue = Number(this.form.get('conclusion_status_id').value);
            if (!this.statuses.map(v => v.id).includes(currentValue)) {
                FormHelperService.updateWithTouch(this.form.get('conclusion_status_id'), '');
            }
        });
    }

    ngOnDestroy() {

    }
}
